module.exports = __webpack_public_path__ + "img/nav-yield.6b72e49f.svg";